// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {dynamicVar} from '../assets/scripts/configmap-variables';
export const environment = {
  production: false,
  baseUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
  contentType: 'application/json',
  colorPrimary: '#7ac7ed',
  colorSecondary: '#337ab7',
  colorPrimaryPartner: '#44D3B5',
  colorSecondaryPartner: '#3AD2D8',
  pageIncrement: 10, // Cant handle value <= 1
  // ONLY DEV
  finalDomain: 'https://partnerhub.timwe.com/',
  serverApiBaseUrl: 'venus-api',
  externalIntegrationPortalAm: window["env"].EXTERNAL_VIVO_AM,
  keycloakUrl: window["env"].KEYCLOAK_URL,
  accesGroupsPrefix: window["env"].ACCESS_GROUP_PREFIX,
  keycloakOpenId: window["env"].BASE_KEYCLOACK_OPEN_ID,
  version: '2.5.3'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
